/**
 * The frame filter's options, in two groups.
 *
 * `seen` is what the tail on screen actually contains: the handful of actions
 * this station is saying right now, which is usually what an operator wants.
 * `other` is every remaining action the message log can hold, so a frame older
 * than the 50-row tail can still be filtered for by name. Without it, an
 * `Authorize` behind a run of `MeterValues` had no option at all.
 *
 * `seen` is not limited to `known`. A station can send an action this server
 * does not implement; it is logged under its own name and answered with
 * `NotImplemented`, and that is exactly the kind of surprise the log exists for.
 */
export function frameActionGroups(
  tailActions: readonly (string | null)[],
  known: readonly string[],
): { readonly seen: readonly string[]; readonly other: readonly string[] } {
  const seen = new Set(tailActions.filter((action): action is string => action !== null));

  return {
    seen: [...seen].sort(),
    other: [...new Set(known)].filter((action) => !seen.has(action)).sort(),
  };
}
